/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./carrerBuy.vue?vue&type=template&id=391a296d&scoped=true&"
import script from "./carrerBuy.vue?vue&type=script&lang=js&"
export * from "./carrerBuy.vue?vue&type=script&lang=js&"
import style0 from "./carrerBuy.vue?vue&type=style&index=0&id=391a296d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391a296d",
  null
  
)

export default component.exports